import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './config/authConfig';
import AccessGuard from './components/AccessGuard';
import AuthButton from './components/AuthButton';
import MapaProyectos from './MapaProyectos';
import './App.css';

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <AccessGuard>
        {/* Header */}
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: '64px',
          backgroundColor: 'white',
          borderBottom: '1px solid #e5e7eb',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 24px'
        }}>
          <h1 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#111827', margin: 0 }}>
            Mapa de Proyectos
          </h1>
          <AuthButton />
        </div>
        
        {/* Cuerpo - MapaProyectos con margen superior para el header */}
        <div style={{ 
          marginTop: '64px',
          height: 'calc(100vh - 64px)',
          width: '100%'
        }}>
          <MapaProyectos />
        </div>
      </AccessGuard>
    </MsalProvider>
  );
}

export default App;